import { createI18n } from 'vue-i18n'
import messages from '@/lang'

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages
})

/**
 * `$t` for code that runs outside a component setup — e.g. the People filter
 * chip builders, which are called from store getters where `useI18n()` has no
 * active instance to bind to. Inside a component, keep using `useI18n()`.
 */
export const translate = (key: string, named: Record<string, unknown> = {}): string => i18n.global.t(key, named)

export default i18n
